import React, {useEffect, useState} from "react";
import { useNavigate , useLocation} from "react-router";


import LocalStorageDataStorer from "../../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../../dataAccessLayer/localStorage/LocalStorageKey";
import QuestionnaireManager from "../../../businessLayer/managers/QuestionnaireManager";
import HttpStatusCode from "../../../utils/httpProtocol/HttpStatusCode";


export default function QuestionnaireSubmission(){

    const navigate = useNavigate();
    const location = useLocation();

    const _tenSecondsInMilliseconds = 5000;
    const [_submissionSuccess, setSubmissionSuccess] = useState(false);
    const [_waitingNotification, setWaitingNotification]= useState(false);
    const [_reportIsCompleted, setReportIsCompleted] = useState(false);

    useEffect(()=>{
        const savedQuestionnaire = LocalStorageDataStorer.getItemKeyFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
        //console.log("useEffect-savedQuestionnaire", savedQuestionnaire);
        if(savedQuestionnaire ){
            QuestionnaireManager.submitQuestionnaireSelectedChoices(questionnaireSubmissionCallback);
            //LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.questionnaireSubmitted, true);
            setSubmissionSuccess(true);
            setTimeout(()=>{
            //console.log("setTimeout-triggered: ", true);
            setWaitingNotification(true);
        }, _tenSecondsInMilliseconds);
        }
        
        setReportIsCompleted(true);
    }, []);

    function onButtonClickedEvent(event){
        //console.log("onButtonClickedEvent-event", event);
        event.preventDefault();
        navigate("/private/main", { state: { fromPage: location.pathname }});
    }

    //#region Private Functions BEGIN
    function questionnaireSubmissionCallback(httpResponse){
        //console.log("questionnaireSubmissionCallback-httpResponse", httpResponse);
        if(httpResponse.code === HttpStatusCode._200ok.code){
            setWaitingNotification(false);
            setReportIsCompleted(true);
        }
    }
    //#region Private Functions END

    return(<div className="flex-column-items-center container-lightblue-submission position-rel">
        <span className="questionnaire-title position-rel mt-50 font-color-white"> Submission Process. </span>
        <span className={`fade-element ${_submissionSuccess ? 'visible' : ''} questionnaire-title position-rel mt-50 font-color-white` }> Questionnaire Submitted successfully. </span>
        {/* <span className={`fade-element ${_waitingNotification ? 'visible' : ''} questionnaire-status-name position-rel mt-15 font-color-white`}> Please wait while we process your answers...</span> */}
         <div className={`fade-element ${_reportIsCompleted ? 'visible' : ''} questionnaire-status-type-container mt-15`}>
             <h1 className="questionnaire-status-type position-rel mt-15 font-color-darkblue"> Your Report is now Complete!</h1> 
             <p className="font-color-darkblue mb-15">You can now go to the Main page and view your Report. </p> 
              <button className="btn-element btn-h45 btn-w115 font-s12 position-rel mt-30"
                onClick={onButtonClickedEvent} > To Main Page </button>
         </div>
    </div>);
}